import React, { useEffect, useState } from 'react';
import './ProductPage1.css';
import HeroSection from './components/heroSection/heroSection';
import MobileHero from './components/heroSection/mobilehero';
import BusinessLoanSection from './components/BusinessSection/BusinessSection';
import BusinessLoanBenefits from './components/WhyConsider/whyConsiderBusinessLoan';
import HowBusinessLoansWork from './components/howBusinessLoanWorks/loanProcess';
import StepsSection from './components/LoanSteps/LoanSteps';
import BusinessLoanCards from './components/shoShouldApplySection/whoShouldApply';
import CTASection from './components/CTASection/ctaSection';
import FooterSection from './components/footer/footer';
import SEO from '../../SEO/SEO';
import ROUTES from '../../constants/RouteData';





export default function ProductPageV1() {
  const [isMobile, setIsMobile] = useState(false);

  // Set mobile flag based on window width
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640); // sm breakpoint in Tailwind
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);





  return (
    <>
      <SEO
        title="Business Loan – Fuel Your Growth | DigitMoney"
        description="Grow your business with DigitMoney Business Loans. Get collateral-free funding up to ₹10,00,000 with fast processing, minimal documentation, flexible tenure, and low interest rates. Suitable for MSMEs, startups, and small businesses across India."
        keywords="Business Loan, MSME Loan, SME Loan, Startup Loan, Business Funding, Small Business Loan, Collateral-Free Loan, Business Expansion, Working Capital Loan, DigitMoney Business Loan"
        image="https://web.digitmoney.in/assets/img/DMIcon.png"
        url={`https://web.digitmoney.in/${ROUTES.home}`}
      />

      <div className="w-full flex flex-col items-center bg-[#FBF8F3]">
        {isMobile ? <MobileHero /> : <HeroSection />}
        <BusinessLoanSection />
        <BusinessLoanBenefits />
        <HowBusinessLoansWork />
        <StepsSection />
        <BusinessLoanCards />
        <CTASection />
        <FooterSection />
      </div>
    </>
  );
}
